import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import VRFOutdoorDetail from '../../components/vrf/VRFOutdoorDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createVRFOutdoor } from '../../redux/vrf/vrf_outdoor_actions';

class VRFOutdoorCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isValid: false, isDirty: false, isSubmittable: false };
    this.detail = undefined;
  }

  onSaveHandler() {
    const data = this.detail.getWrappedInstance().getWrappedInstance().getData();
    this.props.create(data);
  }

  render() {
    const { isCreating, errorMessage, create, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal {...newProps} bsSize="large" aria-labelledby="contained-modal-title-lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t('create vrf outdoor')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VRFOutdoorDetail
            ref={ref => (this.detail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="vrf-outdoor-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.vrfOutdoor.errorMessage,
  isCreating: state.vrfOutdoor.isCreating,
});

const mapDispatchToProps = dispatch => ({
  create: data => defaultRejectHandler(dispatch(createVRFOutdoor(data))),
});

export default translate('translations')(
  connect(mapStateToProps, mapDispatchToProps)(VRFOutdoorCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/vrf/VRFOutdoorCreateModal.js